import BundleReceiptModal from "./BundleReceiptModal";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { showApplyBundleReceiptBottomSheetAction } from "../../store/actions";
import { useTranslation } from "react-i18next";
import { directDeepLink } from "@src/common/deepLinks";

const ApplyBundleReceiptBottomSheet = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const state = useSelector((state) => {
    if (state?.overviewReducer?.overViewDetails?.course?.details?.name) {
      return state?.overviewReducer?.overViewDetails?.course;
    } else return overviewServerData?.course;
  });
  const bundledReceipt = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.bundleData?.bundledReceipt
  );
  const orgId = useSelector(
    (state) => state?.persistedDataReducer?.orgDetails?.organization.id 
  );

  const handleClick = (data) => {
    const deepLinkObj = {
      screen: "UTIL_DOWNLOAD",
      paramOne: data,
      paramTwo: data?.substring(data?.lastIndexOf("/") + 1),
    };
    directDeepLink({}, "UTIL_DOWNLOAD", false)(deepLinkObj);
    // handleStartDownloadContent();
    //  window?.mobile?.performAction?.(
    //    `${"ACTION_DOWNLOAD_FILE"}`,
    //    JSON.stringify(newObj)
    //  );
  };

  return (
    <BundleReceiptModal
      showModal={state}
      handleClose={() => {
        dispatch(showApplyBundleReceiptBottomSheetAction(false));
      }}
      header={""}
    >
      <div className="bundle-receipt-div">
        <div className="bundle-download">
         { orgId == 573212
         ? <button
            onClick={() => handleClick(state?.paymentSummary?.receiptUrl)}
          >
            Download Invoice
          </button>
          :
          <button
            onClick={() => handleClick(state?.paymentSummary?.receiptUrl)}
          >
            Download Receipt
          </button>
          }
          {
            state?.paymentSummary?.platformReceipt ? (
            <button onClick={() => handleClick(state?.paymentSummary?.platformReceipt)}>
              Download Platform Fee Invoice
            </button>):null
          }
           {state?.paymentSummary?.bookReceipt ? (
            <button onClick={() => handleClick(state?.paymentSummary?.bookReceipt)}>
              Download Attached Book Invoice
            </button>
          ):null}
          {bundledReceipt ?
            (<button
              onClick={() => handleClick(bundledReceipt)}>
              Download Books Invoice
            </button>):null
          }
          {state?.paymentSummary?.moneyBackReceipt ? (
            <button onClick={() => handleClick(state?.paymentSummary?.moneyBackReceipt)}>
              Assurance Fee Invoice
            </button>
          ):null}
          {state?.paymentSummary?.guaranteedSelectionProgramFeeReceipt ? (
            <button onClick={() => handleClick(state?.paymentSummary?.guaranteedSelectionProgramFeeReceipt)}>
              Assurance Fee Invoice
            </button>
          ):null}
        </div>
        <span className="border"></span>
        <div className="cancel-button-div">
          <button
            onClick={() =>
              dispatch(showApplyBundleReceiptBottomSheetAction(false))
            }
          >
            CANCEL
          </button>
        </div>
      </div>
    </BundleReceiptModal>
  );
};
export default ApplyBundleReceiptBottomSheet;
